// Device Detection and Redirect
function detectDeviceAndRedirect() {
  // Get screen width and user agent
  const screenWidth = window.innerWidth || document.documentElement.clientWidth;
  const userAgent = navigator.userAgent.toLowerCase();

  // Define tablet/mobile breakpoints
  const isTabletOrMobile = screenWidth <= 1024; // Adjust this value as needed

  // Additional user agent checks for mobile devices
  const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

  // Check if user should be redirected
  if (isTabletOrMobile || isMobileUA) {
    // Prevent infinite redirect loop
    if (!window.location.pathname.includes('/mobile') && !window.location.search.includes('desktop=true')) {
      // Redirect to mobile page
      window.location.href = '/mobile.html';
      return; // Exit function after redirect
    }
  }
}

// Check for redirect before doing anything else
detectDeviceAndRedirect();

// Import classes
import Experience from "../Experience/Experience.js";
import LoadingManager from "./LoadingManager.js";
import SmoothScroll from "./SmoothScroll.js";
import ScrollAnimations from "./ScrollAnimations.js";
import MenuManager from "./MenuManager.js";
import ThemeManager from "./ThemeManager.js";
import ScrollIndicator from "./ScrollIndicator.js";
import HeadlineAnimations from "./HeadlineAnimations.js";
import ProjectsManager from "./ProjectsManager.js";
import ContactAnimations from "./ContactAnimations.js";
import EmailHandler from "./EmailHandler.js";
import AboutTextAnimations from "./AboutTextAnimations.js";
import SkillsAnimations from "./SkillsAnimations.js";// Configuration constants
const LOADING_COMPLETION_DELAY = 750; // ms

// Initialize core systems
function initializeApp() {
  // Get canvas element and validate it exists
  const canvas = document.querySelector("canvas.webgl");
  if (!canvas) {
    console.error(
      "Canvas element not found. Make sure the HTML contains a canvas with class 'webgl'"
    );
    return;
  }

  // Initialize
  const experience = new Experience(canvas);
  const smoothScroll = new SmoothScroll();
  const loadingManager = new LoadingManager();
  const menuManager = new MenuManager();
  const themeManager = new ThemeManager();
  const scrollAnimations = new ScrollAnimations(experience, smoothScroll);
  const scrollIndicator = new ScrollIndicator();
  const headlineAnimations = new HeadlineAnimations();
  const projectsManager = new ProjectsManager();
  const contactAnimations = new ContactAnimations();
  const emailHandler = new EmailHandler();
  const aboutTextAnimations = new AboutTextAnimations();
  const skillsAnimations = new SkillsAnimations();

  // Handle loading completion
  experience.resources.on("ready", () => {
    setTimeout(() => {
      loadingManager.complete();
      // Emit loading complete event
      experience.setLoadingComplete();
    }, LOADING_COMPLETION_DELAY);
  });
}

// Start the application
initializeApp();
